import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';

/**
 * Returns `true` once the given deadline (unix seconds) has been reached.
 * Uses a single `setTimeout` — no polling, no memory leak.
 */
export const useIsDeadlineExpired = signatureDeadline => {
  const $ = _c(3);
  const [isDeadlineExpired, setIsDeadlineExpired] = useState(false);
  let t0;
  let t1;
  if ($[0] !== signatureDeadline) {
    t0 = () => {
      if (!signatureDeadline) {
        setIsDeadlineExpired(false);
        return;
      }
      const now = Math.floor(Date.now() / 1000);
      if (now >= signatureDeadline) {
        setIsDeadlineExpired(true);
        return;
      }
      const remainingMs = (signatureDeadline - now) * 1000;
      const timer = setTimeout(() => {
        setIsDeadlineExpired(true);
      }, remainingMs);
      return () => clearTimeout(timer);
    };
    t1 = [signatureDeadline];
    $[0] = signatureDeadline;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return isDeadlineExpired;
};